<template>
  <ImageGallery2023
    :images="mediaData"
    class="image-gallery"
    @zoom="handleLightboxOpen"
  >
    <template #stageImage="{ selectedImage }">
      <nuxt-img
        v-if="selectedImage"
        class="image-gallery__image"
        :src="selectedImage.large"
        :alt="selectedImage.name"
        sizes="sm:80vw md:80vw lg:636px"
      />
    </template>
  </ImageGallery2023>
</template>

<script setup lang="ts">
import { defineAsyncComponent, type PropType } from 'vue';
import { ImageGallery2023 } from '@i22/td-longtail-vue-components';
import { type LocalImage } from '@i22/rocket';
import { openModal } from '~/composables/modal';

const props = defineProps({
  mediaData: {
    type: Array as PropType<LocalImage[]>,
    required: true,
  },
});

const handleLightboxOpen = (options) => {
  openModal({
    noMaxWidth: true,
    className: 'image-gallery__modal',
    component: {
      is: defineAsyncComponent(() => import('~/components/product-detail/image-gallery-modal.vue')),
      props: {
        images: props.mediaData,
        startIndex: options?.selectedImageIndex || 0,
      },
    },
  });
};
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.image-gallery {
  &__image {
    display: inline-block;
    height: auto;
    aspect-ratio: 1 / 1;
    object-fit: contain;
    width: 100%;
    max-width: 100%;
    max-height: 45vh;
  }
}
</style>

<style lang="scss">
@use 'assets/base' as *;

.image-gallery__modal {
  .base-dialog__body {
    @include mq(false, $mq-sm - 1) {
      padding: 0;
    }
  }

  .base-dialog__footer {
    display: none;
  }
}
</style>
